export default __webpack_public_path__ + "static/media/momo.d65b3574.jpg";